// extracted by mini-css-extract-plugin
export var blue = "_1b-g";
export var brand = "_1b-c";
export var darkGrey = "_1b-f";
export var disabled = "_1b-6";
export var disabledSubtle = "_1b-7";
export var error = "_1b-8";
export var green = "_1b-h";
export var grey = "_1b-e";
export var icon = "_1b-0";
export var inherit = "_1b-b";
export var lightGrey = "_1b-d";
export var orange = "_1b-j";
export var pink = "_1b-l";
export var primary = "_1b-1";
export var purple = "_1b-m";
export var quaternary = "_1b-4";
export var quinary = "_1b-5";
export var red = "_1b-k";
export var secondary = "_1b-2";
export var success = "_1b-a";
export var tertiary = "_1b-3";
export var warning = "_1b-9";
export var white = "_1b-n";
export var yellow = "_1b-i";